/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-CUSTOMER-API API
 * API specification for MALIYONE-CUSTOMER-API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddCustomerComment,
  Address,
  AddressCreate,
  BankDetail,
  BankDetailCreate,
  Birthday,
  ContactDetail,
  ContactDetailCreate,
  Customer,
  CustomerComment,
  CustomerCommentPage,
  CustomerPage,
  Director,
  DirectorCreate,
  GetBirthdaysParams,
  GetCustomerCommentsParams,
  GetCustomerParams,
  GetCustomersParams,
  KycUpdateRequest,
  KycUpdateResponse,
  SearchCustomersParams
} from './schemas/customerServiceSchemas';

import { customAxiosInstanceMutator } from './custom-axios-instance';
/**
 * @summary Create a new customer (individual or corporate)
 */
export const createCustomer = (
    customer: Customer,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Customer>(
      {url: `/customer/api/v1/customers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customer, signal
    },
      );
    }
  


export const getCreateCustomerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: Customer}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: Customer}, TContext> => {

const mutationKey = ['createCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomer>>, {data: Customer}> = (props) => {
          const {data} = props ?? {};

          return  createCustomer(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomer>>>
    export type CreateCustomerMutationBody = Customer
    export type CreateCustomerMutationError = unknown

    /**
 * @summary Create a new customer (individual or corporate)
 */
export const useCreateCustomer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: Customer}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCustomer>>,
        TError,
        {data: Customer},
        TContext
      > => {

      const mutationOptions = getCreateCustomerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get all customers with optional filters
 */
export const getCustomers = (
    params?: GetCustomersParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CustomerPage>(
      {url: `/customer/api/v1/all`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCustomersQueryKey = (params?: GetCustomersParams,) => {
    return [
    `/customer/api/v1/all`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomers>>> = ({ signal }) => getCustomers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomers>>>
export type GetCustomersQueryError = unknown


export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
 params: undefined |  GetCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all customers with optional filters
 */

export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get customer by ID
 */
export const getCustomerById = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Customer>(
      {url: `/customer/api/v1/customers/${customerId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetCustomerByIdQueryKey = (customerId?: string,) => {
    return [
    `/customer/api/v1/customers/${customerId}`
    ] as const;
    }

    
export const getGetCustomerByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerById>>, TError = unknown>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerByIdQueryKey(customerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerById>>> = ({ signal }) => getCustomerById(customerId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerById>>>
export type GetCustomerByIdQueryError = unknown


export function useGetCustomerById<TData = Awaited<ReturnType<typeof getCustomerById>>, TError = unknown>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerById>>,
          TError,
          Awaited<ReturnType<typeof getCustomerById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerById<TData = Awaited<ReturnType<typeof getCustomerById>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerById>>,
          TError,
          Awaited<ReturnType<typeof getCustomerById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerById<TData = Awaited<ReturnType<typeof getCustomerById>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get customer by ID
 */

export function useGetCustomerById<TData = Awaited<ReturnType<typeof getCustomerById>>, TError = unknown>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerByIdQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update an existing customer
 */
export const updateCustomer = (
    customerId: string,
    customer: Customer,
 ) => {
      
      
      return customAxiosInstanceMutator<Customer>(
      {url: `/customer/api/v1/customers/${customerId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customer
    },
      );
    }
  


export const getUpdateCustomerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{customerId: string;data: Customer}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{customerId: string;data: Customer}, TContext> => {

const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {customerId: string;data: Customer}> = (props) => {
          const {customerId,data} = props ?? {};

          return  updateCustomer(customerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = Customer
    export type UpdateCustomerMutationError = void

    /**
 * @summary Update an existing customer
 */
export const useUpdateCustomer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{customerId: string;data: Customer}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {customerId: string;data: Customer},
        TContext
      > => {

      const mutationOptions = getUpdateCustomerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get customer by ID
 */
export const getCustomer = (
    params?: GetCustomerParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Customer>(
      {url: `/customer/api/v1/find`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCustomerQueryKey = (params?: GetCustomerParams,) => {
    return [
    `/customer/api/v1/find`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = unknown


export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 params: undefined |  GetCustomerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get customer by ID
 */

export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Search for customers using various criteria
 */
export const searchCustomers = (
    params?: SearchCustomersParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CustomerPage>(
      {url: `/customer/api/v1/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchCustomersQueryKey = (params?: SearchCustomersParams,) => {
    return [
    `/customer/api/v1/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchCustomersQueryOptions = <TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(params?: SearchCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCustomersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCustomers>>> = ({ signal }) => searchCustomers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof searchCustomers>>>
export type SearchCustomersQueryError = unknown


export function useSearchCustomers<TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(
 params: undefined |  SearchCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomers>>,
          TError,
          Awaited<ReturnType<typeof searchCustomers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchCustomers<TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(
 params?: SearchCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomers>>,
          TError,
          Awaited<ReturnType<typeof searchCustomers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchCustomers<TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(
 params?: SearchCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search for customers using various criteria
 */

export function useSearchCustomers<TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(
 params?: SearchCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Add a director to a corporate customer
 */
export const addDirector = (
    customerId: string,
    directorCreate: DirectorCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Director>(
      {url: `/customer/api/v1/customers/${customerId}/directors`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: directorCreate, signal
    },
      );
    }
  


export const getAddDirectorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDirector>>, TError,{customerId: string;data: DirectorCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addDirector>>, TError,{customerId: string;data: DirectorCreate}, TContext> => {

const mutationKey = ['addDirector'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addDirector>>, {customerId: string;data: DirectorCreate}> = (props) => {
          const {customerId,data} = props ?? {};

          return  addDirector(customerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddDirectorMutationResult = NonNullable<Awaited<ReturnType<typeof addDirector>>>
    export type AddDirectorMutationBody = DirectorCreate
    export type AddDirectorMutationError = void

    /**
 * @summary Add a director to a corporate customer
 */
export const useAddDirector = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDirector>>, TError,{customerId: string;data: DirectorCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addDirector>>,
        TError,
        {customerId: string;data: DirectorCreate},
        TContext
      > => {

      const mutationOptions = getAddDirectorMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Add a address to a customer
 */
export const addAddress = (
    customerId: string,
    addressCreate: AddressCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Address>(
      {url: `/customer/api/v1/customers/${customerId}/address`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addressCreate, signal
    },
      );
    }
  


export const getAddAddressMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAddress>>, TError,{customerId: string;data: AddressCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addAddress>>, TError,{customerId: string;data: AddressCreate}, TContext> => {

const mutationKey = ['addAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAddress>>, {customerId: string;data: AddressCreate}> = (props) => {
          const {customerId,data} = props ?? {};

          return  addAddress(customerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddAddressMutationResult = NonNullable<Awaited<ReturnType<typeof addAddress>>>
    export type AddAddressMutationBody = AddressCreate
    export type AddAddressMutationError = unknown

    /**
 * @summary Add a address to a customer
 */
export const useAddAddress = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAddress>>, TError,{customerId: string;data: AddressCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addAddress>>,
        TError,
        {customerId: string;data: AddressCreate},
        TContext
      > => {

      const mutationOptions = getAddAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Add contact details to a customer
 */
export const addContactDetail = (
    customerId: string,
    contactDetailCreate: ContactDetailCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<ContactDetail>(
      {url: `/customer/api/v1/customers/${customerId}/contacts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactDetailCreate, signal
    },
      );
    }
  


export const getAddContactDetailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addContactDetail>>, TError,{customerId: string;data: ContactDetailCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addContactDetail>>, TError,{customerId: string;data: ContactDetailCreate}, TContext> => {

const mutationKey = ['addContactDetail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addContactDetail>>, {customerId: string;data: ContactDetailCreate}> = (props) => {
          const {customerId,data} = props ?? {};

          return  addContactDetail(customerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddContactDetailMutationResult = NonNullable<Awaited<ReturnType<typeof addContactDetail>>>
    export type AddContactDetailMutationBody = ContactDetailCreate
    export type AddContactDetailMutationError = unknown

    /**
 * @summary Add contact details to a customer
 */
export const useAddContactDetail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addContactDetail>>, TError,{customerId: string;data: ContactDetailCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addContactDetail>>,
        TError,
        {customerId: string;data: ContactDetailCreate},
        TContext
      > => {

      const mutationOptions = getAddContactDetailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Add bank details to a customer
 */
export const addBankDetail = (
    customerId: string,
    bankDetailCreate: BankDetailCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<BankDetail>(
      {url: `/customer/api/v1/customers/${customerId}/bank-details`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bankDetailCreate, signal
    },
      );
    }
  


export const getAddBankDetailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addBankDetail>>, TError,{customerId: string;data: BankDetailCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addBankDetail>>, TError,{customerId: string;data: BankDetailCreate}, TContext> => {

const mutationKey = ['addBankDetail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addBankDetail>>, {customerId: string;data: BankDetailCreate}> = (props) => {
          const {customerId,data} = props ?? {};

          return  addBankDetail(customerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddBankDetailMutationResult = NonNullable<Awaited<ReturnType<typeof addBankDetail>>>
    export type AddBankDetailMutationBody = BankDetailCreate
    export type AddBankDetailMutationError = unknown

    /**
 * @summary Add bank details to a customer
 */
export const useAddBankDetail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addBankDetail>>, TError,{customerId: string;data: BankDetailCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addBankDetail>>,
        TError,
        {customerId: string;data: BankDetailCreate},
        TContext
      > => {

      const mutationOptions = getAddBankDetailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update the KYC last updated timestamp for a corporate customer
 */
export const updateKycTimestamp = (
    customerId: string,
    kycUpdateRequest: KycUpdateRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<KycUpdateResponse>(
      {url: `/customer/api/v1/customers/${customerId}/kyc-update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: kycUpdateRequest, signal
    },
      );
    }
  


export const getUpdateKycTimestampMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateKycTimestamp>>, TError,{customerId: string;data: KycUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateKycTimestamp>>, TError,{customerId: string;data: KycUpdateRequest}, TContext> => {

const mutationKey = ['updateKycTimestamp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateKycTimestamp>>, {customerId: string;data: KycUpdateRequest}> = (props) => {
          const {customerId,data} = props ?? {};

          return  updateKycTimestamp(customerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateKycTimestampMutationResult = NonNullable<Awaited<ReturnType<typeof updateKycTimestamp>>>
    export type UpdateKycTimestampMutationBody = KycUpdateRequest
    export type UpdateKycTimestampMutationError = void

    /**
 * @summary Update the KYC last updated timestamp for a corporate customer
 */
export const useUpdateKycTimestamp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateKycTimestamp>>, TError,{customerId: string;data: KycUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateKycTimestamp>>,
        TError,
        {customerId: string;data: KycUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateKycTimestampMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Activate a customer
 */
export const activateCustomer = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Customer>(
      {url: `/customer/api/v1/customers/${customerId}/activate`, method: 'POST', signal
    },
      );
    }
  


export const getActivateCustomerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateCustomer>>, TError,{customerId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateCustomer>>, TError,{customerId: string}, TContext> => {

const mutationKey = ['activateCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateCustomer>>, {customerId: string}> = (props) => {
          const {customerId} = props ?? {};

          return  activateCustomer(customerId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof activateCustomer>>>
    
    export type ActivateCustomerMutationError = void

    /**
 * @summary Activate a customer
 */
export const useActivateCustomer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateCustomer>>, TError,{customerId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateCustomer>>,
        TError,
        {customerId: string},
        TContext
      > => {

      const mutationOptions = getActivateCustomerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Deactivate a customer
 */
export const deactivateCustomer = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Customer>(
      {url: `/customer/api/v1/customers/${customerId}/deactivate`, method: 'POST', signal
    },
      );
    }
  


export const getDeactivateCustomerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateCustomer>>, TError,{customerId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateCustomer>>, TError,{customerId: string}, TContext> => {

const mutationKey = ['deactivateCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateCustomer>>, {customerId: string}> = (props) => {
          const {customerId} = props ?? {};

          return  deactivateCustomer(customerId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateCustomer>>>
    
    export type DeactivateCustomerMutationError = void

    /**
 * @summary Deactivate a customer
 */
export const useDeactivateCustomer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateCustomer>>, TError,{customerId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateCustomer>>,
        TError,
        {customerId: string},
        TContext
      > => {

      const mutationOptions = getDeactivateCustomerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Blacklist a customer
 */
export const blacklistCustomer = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Customer>(
      {url: `/customer/api/v1/customers/${customerId}/blacklist`, method: 'POST', signal
    },
      );
    }
  


export const getBlacklistCustomerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof blacklistCustomer>>, TError,{customerId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof blacklistCustomer>>, TError,{customerId: string}, TContext> => {

const mutationKey = ['blacklistCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof blacklistCustomer>>, {customerId: string}> = (props) => {
          const {customerId} = props ?? {};

          return  blacklistCustomer(customerId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BlacklistCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof blacklistCustomer>>>
    
    export type BlacklistCustomerMutationError = void

    /**
 * @summary Blacklist a customer
 */
export const useBlacklistCustomer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof blacklistCustomer>>, TError,{customerId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof blacklistCustomer>>,
        TError,
        {customerId: string},
        TContext
      > => {

      const mutationOptions = getBlacklistCustomerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Remove a customer from the blacklist
 */
export const unblacklistCustomer = (
    customerId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Customer>(
      {url: `/customer/api/v1/customers/${customerId}/unblacklist`, method: 'POST', signal
    },
      );
    }
  


export const getUnblacklistCustomerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unblacklistCustomer>>, TError,{customerId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unblacklistCustomer>>, TError,{customerId: string}, TContext> => {

const mutationKey = ['unblacklistCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unblacklistCustomer>>, {customerId: string}> = (props) => {
          const {customerId} = props ?? {};

          return  unblacklistCustomer(customerId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnblacklistCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof unblacklistCustomer>>>
    
    export type UnblacklistCustomerMutationError = void

    /**
 * @summary Remove a customer from the blacklist
 */
export const useUnblacklistCustomer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unblacklistCustomer>>, TError,{customerId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unblacklistCustomer>>,
        TError,
        {customerId: string},
        TContext
      > => {

      const mutationOptions = getUnblacklistCustomerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Add a comment to a customer
 */
export const addCustomerComment = (
    customerId: string,
    addCustomerComment: AddCustomerComment,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CustomerComment>(
      {url: `/customer/api/v1/customers/${customerId}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addCustomerComment, signal
    },
      );
    }
  


export const getAddCustomerCommentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomerComment>>, TError,{customerId: string;data: AddCustomerComment}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addCustomerComment>>, TError,{customerId: string;data: AddCustomerComment}, TContext> => {

const mutationKey = ['addCustomerComment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCustomerComment>>, {customerId: string;data: AddCustomerComment}> = (props) => {
          const {customerId,data} = props ?? {};

          return  addCustomerComment(customerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddCustomerCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addCustomerComment>>>
    export type AddCustomerCommentMutationBody = AddCustomerComment
    export type AddCustomerCommentMutationError = void

    /**
 * @summary Add a comment to a customer
 */
export const useAddCustomerComment = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomerComment>>, TError,{customerId: string;data: AddCustomerComment}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCustomerComment>>,
        TError,
        {customerId: string;data: AddCustomerComment},
        TContext
      > => {

      const mutationOptions = getAddCustomerCommentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get comments for a customer
 */
export const getCustomerComments = (
    customerId: string,
    params?: GetCustomerCommentsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<CustomerCommentPage>(
      {url: `/customer/api/v1/customers/${customerId}/comments`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCustomerCommentsQueryKey = (customerId?: string,
    params?: GetCustomerCommentsParams,) => {
    return [
    `/customer/api/v1/customers/${customerId}/comments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCustomerCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerComments>>, TError = unknown>(customerId: string,
    params?: GetCustomerCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerComments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerCommentsQueryKey(customerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerComments>>> = ({ signal }) => getCustomerComments(customerId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerComments>>>
export type GetCustomerCommentsQueryError = unknown


export function useGetCustomerComments<TData = Awaited<ReturnType<typeof getCustomerComments>>, TError = unknown>(
 customerId: string,
    params: undefined |  GetCustomerCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerComments>>,
          TError,
          Awaited<ReturnType<typeof getCustomerComments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerComments<TData = Awaited<ReturnType<typeof getCustomerComments>>, TError = unknown>(
 customerId: string,
    params?: GetCustomerCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerComments>>,
          TError,
          Awaited<ReturnType<typeof getCustomerComments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerComments<TData = Awaited<ReturnType<typeof getCustomerComments>>, TError = unknown>(
 customerId: string,
    params?: GetCustomerCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerComments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get comments for a customer
 */

export function useGetCustomerComments<TData = Awaited<ReturnType<typeof getCustomerComments>>, TError = unknown>(
 customerId: string,
    params?: GetCustomerCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerComments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerCommentsQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Active directors of business customers, personal customers and business representatives whose birthday falls between from and to (inclusive, at most a year apart). The date of birth is the one recorded, else it is read from a valid South African ID number; people with neither are left out. Sorted by day, then name.
 * @summary Birthdays falling in a date range
 */
export const getBirthdays = (
    params: GetBirthdaysParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Birthday[]>(
      {url: `/customer/api/v1/birthdays`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetBirthdaysQueryKey = (params?: GetBirthdaysParams,) => {
    return [
    `/customer/api/v1/birthdays`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBirthdaysQueryOptions = <TData = Awaited<ReturnType<typeof getBirthdays>>, TError = unknown>(params: GetBirthdaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBirthdays>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBirthdaysQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBirthdays>>> = ({ signal }) => getBirthdays(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBirthdays>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBirthdaysQueryResult = NonNullable<Awaited<ReturnType<typeof getBirthdays>>>
export type GetBirthdaysQueryError = unknown


export function useGetBirthdays<TData = Awaited<ReturnType<typeof getBirthdays>>, TError = unknown>(
 params: GetBirthdaysParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBirthdays>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBirthdays>>,
          TError,
          Awaited<ReturnType<typeof getBirthdays>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBirthdays<TData = Awaited<ReturnType<typeof getBirthdays>>, TError = unknown>(
 params: GetBirthdaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBirthdays>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBirthdays>>,
          TError,
          Awaited<ReturnType<typeof getBirthdays>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBirthdays<TData = Awaited<ReturnType<typeof getBirthdays>>, TError = unknown>(
 params: GetBirthdaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBirthdays>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Birthdays falling in a date range
 */

export function useGetBirthdays<TData = Awaited<ReturnType<typeof getBirthdays>>, TError = unknown>(
 params: GetBirthdaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBirthdays>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBirthdaysQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
